import AdvanteIcons from "../AdvanteIcons";


const Header = () => {
  return (
    <section className="e-commerce-header">
     
      <div className="containerFull">
        <div className="e-commerce-label">
          <div className="e-commerce-icon">
            <AdvanteIcons type="IcoEcommerce" fill="var(--white-color)" />
          </div>
          <h2>Marketplace &amp; Ecommerce Platforms.</h2>
        </div>

        <div className="e-commerce-headline">
          <h1>Highly <br />experienced</h1>

          <div className="e-commerce-headline-copy">
            <p>We maintain and improve marketplaces and ecommerce platforms that are already running: storefronts, checkout and payment flows, subscriptions, admin operations, inventory, and integrations. We help teams move faster while protecting production with staging, QA, pull requests, and controlled deployment.</p>
          </div>
        </div>




      </div>
    </section>
  );
};

export default Header;
